import { useTranslation as useI18nextTranslation } from "react-i18next";

export const useAppTranslation = useI18nextTranslation;
